<div class="sz-lap">
  <div class="ures" *ngIf="!u"><ion-icon name="business-outline"></ion-icon>Válassz céget a fejlécben.</div>
  <ng-container *ngIf="u && !aktiv">
    <div class="n-szuro-sor" *ngIf="ir">
      <label>Raktár <select [(ngModel)]="ujRaktar"><option *ngFor="let r of raktarak" [value]="r.id">{{ r.nev }}</option></select></label>
      <button type="button" class="ov-gomb fo" (click)="indit()"><ion-icon name="barcode-outline"></ion-icon>Új leltár (készletellenőrzés)</button>
    </div>
    <div class="tabla-wrap">
      <table class="n-racs sz-racs">
        <thead><tr><th>Dátum</th><th>Raktár</th><th class="num">Számolt cikk</th><th>Állapot</th><th>Megjegyzés</th></tr></thead>
        <tbody><tr *ngFor="let l of lista" class="kattinthato" (click)="nyit(l)">
          <td><b>{{ l.datum }}</b></td><td>{{ l.raktar_nev }}</td><td class="num">{{ l.db }}</td>
          <td><span class="sz-allapot" [attr.data-a]="l.allapot === 'lezart' ? 'kesz' : 'var'">{{ l.allapot === 'lezart' ? 'lezárva' : 'folyamatban' }}</span></td><td>{{ l.megjegyzes }}</td></tr></tbody>
      </table>
      <div class="sz-ures" *ngIf="!lista.length">Még nem volt leltár.</div>
    </div>
  </ng-container>

  <div class="sa" *ngIf="aktiv">
    <div class="n-szuro-sor" style="padding:0">
      <button type="button" class="ov-gomb" (click)="frissit()"><ion-icon name="arrow-back-outline"></ion-icon>Leltárak</button>
      <b>Leltár {{ aktiv.datum }}</b><span class="sz-allapot" [attr.data-a]="aktiv.allapot === 'lezart' ? 'kesz' : 'var'">{{ aktiv.allapot === 'lezart' ? 'lezárva' : 'folyamatban' }}</span>
      <span class="spacer"></span>
      <span class="halvany">{{ aktiv.tetelek.length }} cikk számolva · {{ elteroDb }} eltérés</span>
      <button type="button" class="ov-gomb fo" *ngIf="ir && aktiv.allapot === 'folyamatban'" (click)="lezar()"><ion-icon name="lock-closed-outline"></ion-icon>Lezárás</button>
    </div>
    <ng-container *ngIf="ir && aktiv.allapot === 'folyamatban'">
      <span class="kv-egyutt"><input #olvasoMezo class="inv-olvaso" [(ngModel)]="olvaso" (keydown.enter)="olvas()" placeholder="Olvasd be a vonalkódot (minden olvasás +1)">
        <app-kamera-olvaso [folyamatos]="true" cim="Leltár: olvasás kamerával (minden olvasás +1)" (olvasott)="olvaso = $event; olvas()"></app-kamera-olvaso></span>
      <p class="halvany" style="margin:0" *ngIf="utolso">Utolsó: <b>{{ utolso }}</b></p>
    </ng-container>
    <table class="n-racs sz-racs">
      <thead><tr><th>Cikk</th><th>Vonalkód</th><th class="num">Számolt</th><th class="num">Könyv szerint</th><th class="num">Eltérés</th><th></th></tr></thead>
      <tbody><tr *ngFor="let t of aktiv.tetelek">
        <td><b>{{ t.nev }}</b> <small class="halvany">{{ t.cikkszam }}</small></td><td>{{ t.vonalkod }}</td>
        <td class="num"><ng-container *ngIf="ir && aktiv.allapot === 'folyamatban'; else csakSzam">
          <button type="button" class="sz-gomb-ikon" (click)="modosit(t, -1)">−</button>
          <input type="number" min="0" [ngModel]="t.szamolt" (change)="beallit(t, $any($event.target).value)" style="width:70px;text-align:right">
          <button type="button" class="sz-gomb-ikon" (click)="modosit(t, 1)">+</button></ng-container>
          <ng-template #csakSzam>{{ szam(t.szamolt) }}</ng-template></td>
        <td class="num">{{ szam(t.konyv) }}</td>
        <td class="num"><span class="inv-elter" [class.plusz]="elteres(t) > 0" [class.minusz]="elteres(t) < 0">{{ elteres(t) > 0 ? '+' : '' }}{{ szam(elteres(t)) }}</span></td>
        <td><button type="button" class="sz-gomb-ikon" *ngIf="ir && aktiv.allapot === 'folyamatban'" (click)="torol(t)" title="Kivesz a listából"><ion-icon name="close-outline"></ion-icon></button></td>
      </tr></tbody>
    </table>
    <ng-container *ngIf="aktiv.hianyzo?.length && aktiv.allapot === 'folyamatban'">
      <h3 class="sz-cim">Hiányzó – készleten van, de még nem olvasták be ({{ aktiv.hianyzo.length }})</h3>
      <table class="n-racs sz-racs"><thead><tr><th>Cikk</th><th>Vonalkód</th><th class="num">Könyv szerint</th></tr></thead>
        <tbody><tr *ngFor="let h of aktiv.hianyzo"><td>{{ h.nev }}</td><td>{{ h.vonalkod }}</td><td class="num">{{ szam(h.konyv) }} {{ h.egyseg }}</td></tr></tbody></table>
    </ng-container>
  </div>
</div>
